import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import LoadingSpinner from '@/components/common/LoadingSpinner.vue'
  import useShopifyClient from '@/composables/useShopifyClient'
  import useSegment from '@/composables/useSegment'
  import useCourse from '@/composables/useCourse'
  import useI18n from '@/composables/useI18n'
  import { DateTime } from 'luxon'
  import useCommonMixin from '@/composables/useCommonMixin'

  import type { CourseItem } from '@/services/interfaces/Course'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'IDDCoursesCheckoutModal',
  props: {
    formattedProductAmount: {
      type: String,
      required: true,
    },
  },
  setup(__props) {

  const { course } = useCourse()
  const { createShopifyCheckout } = useShopifyClient()
  const { coursePurchaseIntended } = useSegment()
  const { translateString } = useI18n()
  const { closeModal } = useCommonMixin()

  

  const initiatingCheckout = ref(false)

  const iddCourses = computed(() => [] as CourseItem[])

  const accessIDDCoursesFrom = computed(() =>
    translateString('courses.accessIDDCoursesFrom', { currentYear: DateTime.now().year }),
  )

  const initiateShopifyCheckout = () => {
    initiatingCheckout.value = true
    coursePurchaseIntended(course.value!.id, course.value!.title, 'course_details_page')
    createShopifyCheckout()
  }

return { __sfc: true,course, createShopifyCheckout, coursePurchaseIntended, translateString, closeModal, initiatingCheckout, iddCourses, accessIDDCoursesFrom, initiateShopifyCheckout, computed, ref, KetchUpButton, LoadingSpinner, useShopifyClient, useSegment, useCourse, useI18n, DateTime, useCommonMixin }
}

})